const kentuckyConfig = {
  urls: {
    cloud: {
      ajax: {
        live: "https://prd.kehds.chfs.ky.gov/api/touch/",
        test: "https://test.kehds.chfs.ky.gov/api/touch/",
      },
      api: {
        live: "https://services-api.kehds.chfs.ky.gov/",
        test: "https://services-api-test.kehds.chfs.ky.gov/",
      },
    },
  },
};

export const configs: any = {
  "mobile.kehds.chfs.ky.gov": kentuckyConfig,
  "mobile-test.kehds.chfs.ky.gov": kentuckyConfig,
  local: {
    urls: {
      cloud: {
        ajax: {
          live: "/live/api/touch/",
          test: "/test/api/touch/",
          dev: "/dev/api/touch/",
          local: "/local/api/touch/",
        },
        api: {
          live: "/services-api-live/",
          test: "/services-api-test/",
          dev: "/services-api-dev/",
          local: "/services-api-local/",
        },
      },
    },
  },
  default: {
    urls: {
      cloud: {
        ajax: {
          live: "https://api.hscloudsuite.com/api/touch/",
          test: "https://test-next.hscloudsuite.com/api/touch/",
          dev: "https://dev-next.hscloudsuite.com/api/touch/",
        },
        api: {
          live: "https://services-api.hscloudsuite.com/",
          test: "https://uat-service-api.hscloudsuite.com/",
          dev: "https://dev-services-api.hscloudsuite.com/",
        },
      },
    },
  },
};
